import { getString } from "../../common/common";

export const HEADING1 = "HEADING1";
export const HEADING2 = "HEADING2";

export const TAB1 = "TAB1";
export const TAB2 = "TAB2";
export const TAB3 = "TAB3";
export const TAB4 = "TAB4";
export const TAB5 = "TAB5";

export const translations = {
  en: {
    [HEADING1]: "Bus Services",
    [HEADING2]: "5 Bus Services",
    [TAB1]: "Fly Bus",
    [TAB2]: "Airavat Club Class",
    [TAB3]: "Airavat Bliss",
    [TAB4]: "Airavat Superia",
    [TAB5]: "Airavat",
  },
  kn: {
    [HEADING1]: "ಬಸ್ ಸೇವೆಗಳು",
    [HEADING2]: "5 ಬಸ್ ಸೇವೆಗಳು",
    [TAB1]: "ಫ್ಲೈ ಬಸ್",
    [TAB2]: "ಐರಾವತ್ ಕ್ಲಬ್ ಕ್ಲಾಸ್",
    [TAB3]: "ಐರಾವತ್ ಬ್ಲಿಸ್",
    [TAB4]: "ಐರಾವತ್ ಸುಪೇರಿಯಾ",
    [TAB5]: "ಐರಾವತ",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
